import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const DataTableWidgetV3: WidgetRegistryEntry = {
  name: "DataTableV3",
  configuration: () => import("./data-table-v3-widget-configuration").then((m) => m.DataTableV3WidgetConfiguration),
  component: () => import("./data-table-v3-widget.component").then((m) => m.DataTableV3WidgetComponent)
};
